import { render, staticRenderFns } from "./SurveyShare.vue?vue&type=template&id=0fed8d16&scoped=true&"
import script from "./SurveyShare.vue?vue&type=script&lang=js&"
export * from "./SurveyShare.vue?vue&type=script&lang=js&"
import style0 from "./SurveyShare.vue?vue&type=style&index=0&id=0fed8d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed8d16",
  null
  
)

export default component.exports